/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import Spinner from '../../../components/loader/spinner';

import { fetchBibsDashboard } from '../../../services/apis/business/bibs';

function BibsDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const [race, setRace] = useState({});
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  const bibsDashboard = useCallback(async raceID => {
    try {
      const response = await fetchBibsDashboard(raceID);

      const { race: details, list } = response;

      setRace(details);
      setStats(list);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const { race: raceID = null } = queryString.parse(location.search);

    (async () => {
      setLoading(true);

      await bibsDashboard(raceID);
    })();
  }, []);

  return (
    <>
      <Helmet>
        <title>{race?.name ? `${race?.name} | Bibs Dashboard` : 'Loading...'}</title>
      </Helmet>
      <div className="relative">
        <div
          className="home absolute w-full h-48 bg-center bg-contain bg-no-repeat"
          style={{
            backgroundImage: `url(${race.cover})`,
          }}>
          <div className="w-full h-52 absolute opacity-50 bg-black" style={{ zIndex: 1 }} />
        </div>
        <div className="sticky" style={{ zIndex: 2 }}>
          <div className="novoHealth-banner bg-transparent h-48">
            <p className="title">{race?.name}</p>
            <p className="subTitle">Bibs Dashboard</p>
          </div>
        </div>
      </div>
      {loading && (
        <div className="container max-w-5xl mx-auto pb-6 px-6">
          <div className="mt-8">
            <Spinner size="medium" />
          </div>
        </div>
      )}
      {!loading && (
        <div className="container max-w-4xl mx-auto pt-10 px-6 md:px-8">
          <h1 className="text-lg font-bold">Stats</h1>
          <div className="grid grid-cols-12 gap-x-6 gap-y-4 mt-4 mb-2">
            {stats.length > 0 ? (
              stats.map(item => {
                const collected = item.total - item.left;
                const collectedPerc = (collected / item.total) * 100;

                return (
                  <div
                    key={item.raceCategory}
                    className="col-span-12 sm:col-span-4 xl:col-span-4 flex flex-col duration-1000 transition-all cursor-pointer rounded-xl"
                    role="presentation"
                    onClick={() =>
                      navigate(`/bibs/list?race=${race.id}&event=${item.raceCategory}`)
                    }>
                    <div className="bg-white flex flex-col h-full shadow-lg rounded-xl relative border border-gray-300 mb-4">
                      <div className="text-center py-4 px-3">
                        <h3 className="text-base font-semibold leading-normal">
                          {item.raceCategory}
                        </h3>
                        <br />
                        <h3 className="text-sm leading-normal">
                          Self: <strong>{item.collectedBySelf}</strong>
                        </h3>
                        <h3 className="text-sm leading-normal">
                          Authorized Individual:{' '}
                          <strong>{item.collectedByAuthorizedIndividual}</strong>
                        </h3>
                        <h3 className="text-sm leading-normal">
                          Collected:{' '}
                          <strong>
                            {collected} ({collectedPerc.toFixed(2)}%)
                          </strong>
                        </h3>
                        <h3 className="text-sm leading-normal">
                          Not Collected: <strong>{item.left}</strong>
                        </h3>
                        <h3 className="text-sm leading-normal">
                          Total Runners: <strong>{item.total}</strong>
                        </h3>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-span-12">
                <p className="mb-1 text-md">
                  <strong>No Events Found</strong>
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default BibsDashboard;
